import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constant";
import emptyState from "./emptyState";

const {
  CALL_STATE,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  SELECTED_OU,
  SELECTED_BR,
  SELECTED_BR_ENTITLEMENTS,
  TARGET_BR,
  ADDED_ENT,
  DELETED_ENT,
  TOTAL_ENT,
  ENTITLEMENTS,
  SOD_CONFLICTS_BR,
  CHAIN_ENTITLEMENTS,

  STEP_ONE,
  STEP_TWO,
  STEP_FOUR,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.ADMIN_BR_OU_REQUEST]: (state: any, action: any) => {
    return immutableSet([STEP_ONE, LOADER_IDENTIFIER], true, state);
  },

  [actionTypes.ADMIN_BR_OU_REQUEST_SUCCESS]: (state: any, action: any) => {
    let modifiedOus: any[] = [];
    let { ous, ...paginationData } = action.payload;
    ous.forEach((ou: any) => {
      let modifiedOu = {
        id: ou.id,
        ouCode: ou.code,
        identitySystemId: ou.identitySystemId,
        name: ou.name,
        description: ou.description,
        ownerCode: ou.ownerCode,
        properties: ou.properties,
      };
      modifiedOus.push(modifiedOu);
    });
    let modifiedPayload = {
      ...paginationData,
      ous: modifiedOus,
    };
    return compose(
      immutableSet([STEP_ONE, LIST_IDENTIFIER], modifiedPayload),
      immutableSet([STEP_ONE, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.ADMIN_BR_OU_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, LOADER_IDENTIFIER], false, state),

  [actionTypes.ADMIN_BR_SELECT_OU]: (state: any, action: any) =>
    immutableSet([SELECTED_OU], action.payload, state),

  [actionTypes.ADMIN_BR_BR_REQUEST]: (state: any, action: any) => {
    return immutableSet([STEP_TWO, LOADER_IDENTIFIER], true, state);
  },

  [actionTypes.ADMIN_BR_BR_REQUEST_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_TWO, LIST_IDENTIFIER], action.payload),
      immutableSet([STEP_TWO, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.ADMIN_BR_BR_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, LOADER_IDENTIFIER], false, state),

  [actionTypes.ADMIN_BR_SELECT_BR]: (state: any, action: any) => {
    // const brEntitlements = action.payload.entitlements;
    return compose(
      immutableSet([SELECTED_BR], action.payload)
      // immutableSet([TOTAL_ENT], brEntitlements)
    )(state);
  },

  [actionTypes.SOD_CONFLICTS_ADMIN_BR_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, SOD_CONFLICTS_BR], action.payload, state),

  [actionTypes.SOD_CONFLICTS_ADMIN_BR_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_TWO, SOD_CONFLICTS_BR], action.payload, state),

  [actionTypes.RESET_SOD_CONFLICTS_ADMIN_BR]: (state: any, action: any) =>
    immutableSet([STEP_TWO, SOD_CONFLICTS_BR], null, state),

  [actionTypes.ADMIN_BR_RESET_BR]: (state: any, action: any) => {
    return compose(
      immutableSet([SELECTED_BR], null),
      immutableSet([ADDED_ENT], []),
      immutableSet([DELETED_ENT], []),
      immutableSet([TOTAL_ENT], [])
    )(state);
  },

  [actionTypes.ADMIN_BR_UPDATE_TARGET_BR]: (state: any, action: any) =>
    immutableSet([TARGET_BR], action.payload, state),

  [actionTypes.ADMIN_BR_SET_ENTITLEMENTS_TARGET_BR]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER],
      [...action.payload],
      state
    ),

  [actionTypes.ADMIN_BR_SET_CHAIN_ENTITLEMENTS_BR]: (state: any, action: any) =>
    immutableSet([CHAIN_ENTITLEMENTS], action.payload, state),

  [actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_FOUR, LOADER_IDENTIFIER], true, state),

  [actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.entitlement_id,
          application_name: data.application_name,
          application_description: data.application_description,
          entitlement_name: data.entitlement_name,
          entitlement_description: data.entitlement_description,
          application_id: data.application_id,
          identity_system_id: data.identity_system_id,
          chainEntitlementsIds: data.chainEntitlementsIds,
          editable: data.editable,
          deleted: false,
          added: false,
          validable: data.validable,
          monoProfilo: data.monoProfilo,
          involvedInSOD: data.involvedInSOD,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([STEP_FOUR, LIST_IDENTIFIER], mappedResponse),
      immutableSet([STEP_FOUR, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_FOUR, LIST_IDENTIFIER], []),
      immutableSet([STEP_FOUR, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LOADER_IDENTIFIER], true)
    )(state),
  [actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([TOTAL_ENT], action.payload),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER], action.payload),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.ADMIN_BR_DELETE_BR_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.ADMIN_BR_DELETE_BR_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_BR_DELETE_BR_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
